import axios from "axios";
import { useEffect, useState } from "react";
import { useErrorHandler } from "./useErrorHandler";
import * as Yup from "yup";
import { propertySchema } from "../schemas/property.schema";
import { successToastHook } from "../components/toasts/success";
import { useLayoutStore } from "../store/layout.store";
import { useRegisterStore } from "../store/register.store";
import {
  createPropertyAsync,
  fetchPropertiesAsync,
} from "../actions/properties.actions";

export const useProperties = () => {
  const { handleError } = useErrorHandler();
  const { setAsideBarOpened } = useLayoutStore((state) => state);
  const { allProperties, setAllProperties, allClients } =
    useRegisterStore((state) => state);

  const useListProperties = () => {
    const [loading, setLoading] = useState(false);

    const fetchProperties = () => {
      setLoading(true);

      fetchPropertiesAsync()
        .then((res: any) => {
          setAllProperties(res?.data?.properties || []);
          setLoading(false);
        })
        .catch((error) => {
          setAllProperties([]);
          setLoading(false);

          handleError(error);
        });
    };

    useEffect(() => {
      fetchProperties();
    }, []);

    return {
      properties: allProperties,
      loading,
    };
  };

  const useAddEditProperty = (id?: string) => {
    const [loading, setLoading] = useState(false);

    const fetchProperties = async () => {
      try {
        const data = await axios.get(`/api/properties`);

        setAllProperties(data?.data?.properties);
      } catch (error) {
        handleError(error);
      }
    };

    const submitData = ({
      values,
      onSuccess,
    }: {
      values: Yup.InferType<typeof propertySchema>;
      onSuccess?: () => void;
    }) => {
      setLoading(true);

      if (!id) {
        createPropertyAsync({
          values: values,
        })
          .then((res) => {
            setLoading(false);

            successToastHook({ msg: "Property added successfully!!" });

            fetchProperties();

            setTimeout(() => {
              if (onSuccess) {
                onSuccess();
              }

              setAsideBarOpened(false);
            }, 1000);
          })
          .catch((error) => {
            setLoading(false);

            handleError(error);
          });
      }
    };

    return {
      submitData,
      loading,
      clientSelectData: allClients?.map((client) => ({
        label: client.name,
        value: client.id,
      })),
    };
  };

  const onCancel = ({ action }: { action?: () => void }) => {
    setAsideBarOpened(false);
    if (action) {
      action();
    }
  };

  return {
    useListProperties,
    useAddEditProperty,
    onCancel,
  };
};
